<template>
  <div>
    <v-sheet>
      <v-form
        ref="form"
        v-model="valid"      
      >
        <v-container>
          <v-toolbar flat>
            <v-btn
              text
              @click="onCancel"
            >
              <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-chevron-left</v-icon>
              <div class="hidden-xs-only">{{ backButtonText }}</div>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click.stop="onSubmit"
              :loading="loading"
            >
              <v-icon :left="$vuetify.breakpoint.smAndUp">mdi-check</v-icon>
              <div class="hidden-xs-only">{{ submitButtonText }}</div>
            </v-btn>
          </v-toolbar>
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="documento"
                placeholder="Ingrese un número de documento"
                label="Número"
                :rules="rules.documento"
                prepend-icon="mdi-counter"
                color="primary"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="razonSocial"
                placeholder="Ingrese apellido y nombre"
                label="Apellido y nombre"
                :rules="rules.razon_social"
                prepend-icon="mdi-counter"
                color="primary"
                clearable
              ></v-text-field>
            </v-col>
            <!-- <v-col cols="12">
              <v-text-field
                v-model="apellido"
                placeholder="Ingrese un apellido"
                prepend-icon="mdi-map-marker"
                label="Apellido"
                :rules="rules.apellido"
                color="primary"
                clearable
              ></v-text-field>
            </v-col> -->
            <!-- <v-col cols="12">
              <v-text-field
                v-model="nombre"
                placeholder="Ingrese un nombre"
                :rules="rules.nombre"
                prepend-icon="mdi-label"
                label="Nombre"
                color="primary"
                clearable
              ></v-text-field>
            </v-col> -->
          </v-row>
        </v-container>
      </v-form>
    </v-sheet>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  components: {
    //
  },
  data () {
    return {
      valid: false,
      submitButtonText: 'Guardar',
      backButtonText: 'Volver',
    }
  },
  created () {
    this.onDefaults()
  },
  computed: {
    ...mapGetters({
      edited: 'Clientes/edited',
      rules: 'Clientes/rules',
      loading: 'Clientes/loading',
    }),
    documento: {
      get () {
        return this.edited.documento
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          documento: value
        })
      }
    },
    razonSocial: {
      get () {
        return this.edited.razon_social
      },
      set (value) {
        this.setEdited({
          ...this.edited,
          razon_social: value
        })
      }
    },
    inactivo: {
      get () {
        return !this.edited.inactivo ? false : true
      },
      set (value) {
        const aux = !value ? null : value
        this.setEdited({
          ...this.edited,
          inactivo: aux
        })
      }
    },

  },
  methods: {
    ...mapActions({
      onSave: 'Clientes/onSave',
      onDefaults: 'Clientes/onClearEdited',
    }),
    ...mapMutations({
      setEdited: 'Clientes/setEdited',

      setDocumento: 'Clientes/setDocumento',
      setRazonSocial: 'Clientes/setRazonSocial',
      setApellido: 'Clientes/setApellido',
      setNombre: 'Clientes/setNombre',
    }),
    onCancel () {
      this.$router.go(-1)
    },
    onSubmit () {
      this.onSave().then(response => {
        this.$router.go(-1)
      })
    },
  },
}
</script>
